// @flow
import { hideDialog } from '../../../react/features/base/dialog/actions';
import { translate } from '../../../react/features/base/i18n/functions';
import Dialog from '../../../react/features/base/ui/components/web/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import Env from '../../modules/Environment';
import {
    NAVIGATION_FEATURE_TUTORIAL,
    NAVIGATION_FULL_TUTORIAL,
    NAVIGATION_INITIAL_STEP,
    TUTORIAL_NAME
} from '../../modules/Tutorial/constants';
import WildixEvents from '../../service/WildixEvents';
import WildixUIEvents from '../../service/WildixUIEvents';

type Props = {

    fullTutorial?: Object,

    featureTutorial?: Object,

    listNewFeatures: Array<Object>,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Dispatch<any>,
}

class ShowTutorialDialog extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        APP.wildix.eventEmitter.emit(WildixEvents.DIALOG_TUTORIAL_OPENED);
        APP.wildix.eventEmitter.emit(WildixUIEvents.DIALOG_OPENED, { type: TUTORIAL_NAME });
    }

    onCancel = () => {
        this.props.dispatch(hideDialog());

        if (Env.isWizyconf()) {
            APP.wildix.eventEmitter.emit(WildixUIEvents.DIALOG_CLOSED, { type: TUTORIAL_NAME });
        }
    };

    getTextFullTutorialByStep() {
        const { fullTutorial: { currentStep, maxCountSteps }, t } = this.props;

        if (currentStep === 0) {
            return t('tutorial.btnPlayTutorial');
        } else if (currentStep < maxCountSteps) {
            return t('tutorial.btnContinue');
        }

        return t('tutorial.btnReplay');
    }

    getTextFeatureTutorialByStep() {
        const { featureTutorial: { currentStep }, t } = this.props;

        if (currentStep === null || this.isFeatureWatched) {
            return t('tutorial.btnAllFeature');
        }

        return t('tutorial.btnContinue');
    }

    get getStepFeature() {
        const { featureTutorial: { currentStep } } = this.props;

        if (currentStep === null || this.isFeatureWatched) {
            return NAVIGATION_INITIAL_STEP;
        }

        return currentStep;
    }

    get isFullWatched() {
        const { fullTutorial: { currentStep, maxCountSteps } } = this.props;

        return currentStep === maxCountSteps;
    }
    get isFeatureWatched() {
        const { featureTutorial: { isAllStepsWereShow } } = this.props;

        return isAllStepsWereShow;
    }

    runTutorial(dataObject) {
        const { dispatch } = this.props;

        APP.wildix.eventEmitter.emit(WildixEvents.SHOW_TUTORIAL, dataObject);

        dispatch(hideDialog());
    }

    render() {
        const { listNewFeatures, fullTutorial, t } = this.props;

        return (
            <Dialog
                hideCancelButton = { true }
                submitDisabled = { true }
                onCancel = { this.onCancel }
                titleKey='tutorial.dialogTitle'
                size = 'large'>
                <div className="dialog-tutorial-group">
                    <div className={`dialog-tutorial-list ${this.isFullWatched ? 'watched' : ''}`}
                        key={'basic-tutorial'}>
                        <div className="dialog-tutorial-list__left">
                            {this.isFullWatched && <div className="checkmark">L</div>}
                            <span className="dialog-tutorial-title">
                                {t('tutorial.titleBasicTutorial')}
                            </span>
                        </div>
                        <div className="dialog-tutorial-btn" onClick={this.runTutorial.bind(this, {
                            type: NAVIGATION_FULL_TUTORIAL,
                            step: this.isFullWatched ? NAVIGATION_INITIAL_STEP : fullTutorial.currentStep
                        })}>
                            {this.getTextFullTutorialByStep()}
                        </div>
                    </div>
                </div>
                <div className="dialog-tutorial-group dialog-tutorial_margin">
                    <div className={`dialog-tutorial-list ${this.isFeatureWatched ? 'watched' : ''}`}
                        key={'feature-tutorial'}>
                        <div className="dialog-tutorial-list__left">
                            {this.isFeatureWatched && <div className="checkmark">L</div>}
                            <span className="dialog-tutorial-title">
                                {t('tutorial.titleLatestFeature')}
                            </span>
                        </div>
                        <div className="dialog-tutorial-btn" onClick={this.runTutorial.bind(this, {
                            type: NAVIGATION_FEATURE_TUTORIAL,
                            step: this.getStepFeature
                        })}>
                            {this.getTextFeatureTutorialByStep()}
                        </div>
                    </div>
                    <div className="dialog-list__divider"></div>
                    {listNewFeatures.map((item, index) => (
                        <div className={`dialog-tutorial-list ${item.wasShowed ? 'watched' : ''}`} key={index}>
                            <div className="dialog-tutorial-list__left">
                                {!item.wasShowed && <span className={'tutorial-new'}>({t('tutorial.titleNew')})</span>}
                                {item.wasShowed && <div className="checkmark">L</div>}
                                <span className="dialog-tutorial-title">
                                    {item.title}
                                </span>
                            </div>
                            <div className="dialog-tutorial-btn" onClick={this.runTutorial.bind(this, item.callObj)}>
                                {t('tutorial.btnShowTutorial')}
                            </div>
                        </div>
                    ))}
                </div>
            </Dialog>
        );
    }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state): Object {
    const { currentStage, listNewFeatures, ...restParams } = state['wildix/features/tutorial'];

    return {
        _currentStage: currentStage,
        fullTutorial: restParams[NAVIGATION_FULL_TUTORIAL],
        featureTutorial: restParams[NAVIGATION_FEATURE_TUTORIAL],
        listNewFeatures
    };
}


export default translate(connect(_mapStateToProps, null)(ShowTutorialDialog));
